import { ColumnMain } from "#/models/column-main";
import { Column } from "#/models/column";
import { Trans } from "@lingui/macro";
import { Tag } from "antd";
import React from "react";

const EmailModel = (): ColumnMain => {

    const columns : Array<Column> = new Array();
    
    columns.push({key:'id', width: 80, filter:true, sorter:true, title:<Trans>ID</Trans>});
    columns.push({key:'recipients', width: 250, filter:true, sorter:true, title:<Trans>Recipients</Trans>});
    columns.push({key:'subject', width: 300, filter:true, sorter:true, title:<Trans>Subject</Trans>});
    columns.push({
        key: 'type',
        uniqueSelectFilterData: [
            {
                label: <Trans>All</Trans>,
                value: null,
            },
            {
                label: <Trans>NOTIFICATION</Trans>,
                value: 'NOTIFICATION',
            },
            {
                label: <Trans>SYSTEM</Trans>,
                value: 'SYSTEM',
            },
            {
                label: <Trans>USER</Trans>,
                value: 'USER',
            }
        ],
        sorter: true,
        width: 180,
        title: <Trans>Type</Trans>,
        render: text => {
            let color = 'gray';
            let transText;
            if (text === 'NOTIFICATION') {
                color = 'blue';
                transText = <Trans>NOTIFICATION</Trans>;
            } else if (text === 'SYSTEM') {
                color = 'purple';
                transText = <Trans>SYSTEM</Trans>;
            } else if (text === 'USER') {
                color = 'green';
                transText = <Trans>USER</Trans>;
            }
            return (
                <Tag color={color} key={text}>
                    {transText}
                </Tag>
            );
        },
    });
    columns.push({
        key: 'status',
        uniqueSelectFilterData: [
            {
                label: <Trans>All</Trans>,
                value: null,
            },
            {
                label: <Trans>CREATED</Trans>,
                value: 'CREATED',
            },
            {
                label: <Trans>SENT</Trans>,
                value: 'SENT',
            },
            {
                label: <Trans>ERROR</Trans>,
                value: 'ERROR',
            }
        ],
        sorter: true,
        width: 150,
        title: <Trans>Status</Trans>,
        render: text => {
            let color = 'gray';
            let transText;
            if (text === 'CREATED') {
                color = 'orange';
                transText = <Trans>CREATED</Trans>;
            } else if (text === 'SENT') {
                color = 'green';
                transText = <Trans>SENT</Trans>;
            } else if (text === 'ERROR') {
                color = 'red';
                transText = <Trans>ERROR</Trans>;
            }
            return (
                <Tag color={color} key={text}>
                    {transText}
                </Tag>
            );
        },
    });
    columns.push({key:'sentAt', width: 180, dateTimeFilter:true, sorter:true, title:<Trans>Sent At</Trans>});
    columns.push({key:'updatedDate', width: 180, dateTimeFilter:true, sorter:true, title:<Trans>Updated Date</Trans>});
    columns.push({key:'updatedBy', width: 200, filter:true, sorter:true, title:<Trans>Updated By</Trans>});
    columns.push({key:'createdDate', width: 180, dateTimeFilter:true, sorter:true, title:<Trans>Created Date</Trans>, direction:"desc"});
    columns.push({key:'createdBy', width: 200, filter:true, sorter:true, title:<Trans>Created By</Trans>});

    return {
        columns: columns,
        url: "/resource/emails"
    };

}
export default EmailModel();
